export class objetoEmailLink{
    Email: string;
    Url: string;
  }